module.exports = __webpack_public_path__ + "static/img/apple-1.254fdde9.jpg";